/* eslint-disable no-undef */
import * as React from "react";
import Progress from "./Progress";
import FunctionalityButtonStack from "./FunctionalityButtonStack";
import HelpStack from "./HelpStack";
import { Spinner, Stack, Text } from "@fluentui/react";
import axios from "axios";
import CompareButtonStack from "./CompareButtonStack";
import { getToken } from "@/helpers/accessTokenHelper";
import { getSiteIdentifier, getSiteUrl } from "@/helpers/siteIdentifierHelper";
import { getDocumentLink, getIsCompared, getIsRedlined, getPdfUrl } from "@/helpers/fallback-response-helper";
import ComparedDetails from "./ComparedDetails";
import Details from "./Details";
import BTLogo from "./BTLogo";
import NoticeBar from "./NoticeBar";

const App = (props) => {
  const { title, isOfficeInitialized } = props;
  const [loading, setLoading] = React.useState(false);
  const [isCompared, setIsCompared] = React.useState(false);
  const [displayPdfWarning, setDisplayPdfWarning] = React.useState(false);
  const [data, setData] = React.useState(null);
  const [refreshDocument, setRefreshDocument] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [status, setStatus] = React.useState(false);
  const [isRedlined, setIsRedlined] = React.useState(true);
  const [graphToken, setGraphToken] = React.useState("");
  const [isNewUser, setIsNewUser] = React.useState(false);
  const [url, setUrl] = React.useState("");
  const [error, setError] = React.useState(false);
  const [documentDetails, setdocumentDetails] = React.useState(null);
  React.useEffect(() => {
    Office.onReady(async () => {
      setLoading(true);
      var to2 = await getToken();
      setGraphToken(to2);
    });
  }, []);
  React.useEffect(() => {
    if (graphToken?.length) {
      Office.context.document.getFilePropertiesAsync(async (context) => {
        axios
          .get(`https://addins.api.dexterity.legal/gateway/api/v1/user`, {
            headers: {
              Authorization: `Bearer ${graphToken}`,
              "Site-Identifier": getSiteIdentifier(context.value.url),
              "Ocp-Apim-Subscription-Key": "6a6c8e6075cc4402a6839fa2ecc950f1",
            },
          })
          .then((response) => {
            setIsNewUser(response.data?.data?.dataDictionary?.isFirstLogin);
          })
          .catch(() => {
            setIsLoading(false);
            setError(true);
          });
      });
    }
  }, [graphToken]);

  const openWarningPdfDialog = () => {
    Office.context.document.getFilePropertiesAsync(async () => {
      Office.context.ui.displayDialogAsync(
        `${process.env.BASE_URL}/WarningPDF.html`,
        {
          width: 40,
          height: 32,
          displayInIframe: true,
        },
        (result) => {
          var dialog = result.value;
          dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
            if (arg.message === "IAmReady") {
              dialog.messageChild();
            }
            if (arg.message === "close") {
              dialog.close();
            }
          });
        }
      );
    });
  };
  React.useEffect(() => {
    let pdfUrl = getPdfUrl(documentDetails);

    if (documentDetails && pdfUrl && displayPdfWarning) {
      openWarningPdfDialog();
    }
  }, [documentDetails, displayPdfWarning]);
  React.useEffect(() => {
    if (graphToken.length) {
      setLoading(true);
      Office.context.document.getFilePropertiesAsync(async (context) => {
        axios
          .get(
            `https://addins.api.dexterity.legal/gateway/api/v1/documents/item?url=${encodeURIComponent(
              context.value.url
            )}&byPass=true`,
            {
              headers: {
                Authorization: `Bearer ${graphToken}`,
                "Site-Identifier": getSiteIdentifier(context.value.url),
                "Ocp-Apim-Subscription-Key": "6a6c8e6075cc4402a6839fa2ecc950f1",
              },
            }
          )
          .then((response) => {
            setdocumentDetails(response?.data?.data);
            setUrl(getDocumentLink(response));
            if (response.data) {
              axios.patch(
                `https://addins.api.dexterity.legal/gateway/api/v1/documents/accessed/${response.data?.data?.id}`,
                {},
                {
                  headers: {
                    Authorization: `Bearer ${graphToken}`,
                    "Site-Identifier": getSiteIdentifier(context.value.url),
                    "Ocp-Apim-Subscription-Key": "6a6c8e6075cc4402a6839fa2ecc950f1",
                  },
                }
              );
              setData(response.data?.data);
              var doc = JSON.stringify(response.data?.data);
              sessionStorage.setItem("document", doc);
              setIsCompared(getIsCompared(response));
              setIsRedlined(getIsRedlined(response));
              setDisplayPdfWarning(!getIsCompared(response));
              setLoading(false);
            } else {
              setLoading(false);
            }
          })
          .catch((error) => {
            console.log("Error in ItemId API", error);
            setLoading(false);
          });
      });
    }
  }, [graphToken, refreshDocument]);

  if (!isOfficeInitialized || loading) {
    return (
      <Progress
        title={title}
        logo={require("./../../../assets/icon-128.png")}
        message="Please wait while we configure Dexterity"
      />
    );
  }

  const Loading = () => {
    return (
      <Stack
        style={{
          padding: "7%",
          alignSelf: "center",
          width: "100%",
        }}
      >
        <Spinner title="Loading..." />
      </Stack>
    );
  };

  const handleRedirection = () => {
    Office.context.document.getFilePropertiesAsync(async (context) => {
      const domainUrl = getSiteUrl(context.value.url);
      console.log("domainUrl", domainUrl);
      window.open(domainUrl, "_blank");

      Office.context.ui.displayDialogAsync(
        domainUrl,
        {
          height: 50,
          width: 50,
          displayInIframe: true
        },
        (asyncResult) => {
          if (asyncResult.status === Office.AsyncResultStatus.Failed) {
            console.error("Dialog failed:", asyncResult.error.message);
          } else {
            const dialog = asyncResult.value;
            dialog.close(); // Optional if you just want to launch the browser
          }
        }
      );
    });
  };

  const getStarted = async () => {
    Office.context.document.getFilePropertiesAsync(async (context) => {
      setIsNewUser(false);
      axios.patch(
        `https://addins.api.dexterity.legal/gateway/api/v1/user/first-login`,
        {},
        {
          headers: {
            Authorization: `Bearer ${graphToken}`,
            "Site-Identifier": getSiteIdentifier(context.value.url),
            "Ocp-Apim-Subscription-Key": "6a6c8e6075cc4402a6839fa2ecc950f1",
          },
        }
      );
    });
  };
  const NewUser = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          height: "90vh",
        }}
      >
        <img src={require("../../../assets/Welcome.png")} width={"100%"} />
        <button
          style={{
            width: "50%",
            backgroundColor: "#18468F",
            borderRadius: "20px",
            paddingTop: "10px",
            paddingBottom: "10px",
            color: "white",
            borderWidth: "0",
            fontFamily: "Poppins",
            cursor: "pointer",
          }}
          onClick={getStarted}
        >
          Get Started
        </button>
      </div>
    );
  };

  return isNewUser ? (
    <NewUser />
  ) : (
    <div style={{ flexGrow: 1 }}>
      <NoticeBar />
      <div
        style={{
          display: "flex",
          minHeight: "100vh",
          maxHeight: "max-content",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: "1vh",
          alignItem: "center",
          backgroundColor: "white",
          position: "relative",
        }}
      >
        {data && !error ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1vh",
              alignItem: "center",
              flexGrow: 1,
            }}
          >
            <div
              onClick={() => handleRedirection()}
              style={{ cursor: "pointer", marginTop: "1vh", alignSelf: "center" }}
            >
              <BTLogo />
            </div>
            {isLoading ? (
              <Loading />
            ) : isCompared ? (
              <div style={{ flexGrow: 1 }}>
                <CompareButtonStack
                  setLoading={setIsLoading}
                  refreshDocument={refreshDocument}
                  setRefreshDocument={setRefreshDocument}
                  status={status}
                  setStatus={setStatus}
                  isRedlined={isRedlined}
                  url={url}
                />
                <ComparedDetails graphToken={graphToken} />
              </div>
            ) : (
              <>
                <div style={{ flexGrow: 1 }}>
                  <FunctionalityButtonStack
                    refreshDocument={refreshDocument}
                    setRefreshDocument={setRefreshDocument}
                    setLoading={setIsLoading}
                    url={url}
                  />
                  <Details
                    refreshDocument={refreshDocument}
                    setRefreshDocument={setRefreshDocument}
                    graphToken={graphToken}
                  />
                </div>
                <HelpStack />
              </>
            )}
          </div>
        ) : (
          <Stack
            style={{
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              padding: "2vh",
            }}
          >
            <Text style={{ fontSize: "4vh", fontFamily: "Poppins" }}>
            This Document is not registered with Dexterity. Please upload it to the Dexterity platform to access the Dexterity Add In.
            </Text>
          </Stack>
        )}
      </div>
    </div>
  );
};

export default App;
